const mockData = {
  fieldsData: [
    {
      id: 1,
      name: "North Field",
      crop: "Wheat",
      area: "5.2 acres",
      plantedDate: "2024-01-15",
      expectedHarvest: "2024-05-15",
      overallHealth: 78,
      status: "good",
      metrics: {
        soilMoisture: 65,
        temperature: 22,
        humidity: 45,
        ph: 6.8,
      },
      location: { lat: 30.7333, lng: 76.7794 },
      image: null,
      lastWatered: "2024-01-20",
      fertilizer: "NPK 10-26-26",
      irrigation: "Drip irrigation",
      soilType: "Loamy",
    },
    {
      id: 2,
      name: "South Field",
      crop: "Rice",
      area: "3.8 acres",
      plantedDate: "2024-01-10",
      expectedHarvest: "2024-06-10",
      overallHealth: 85,
      status: "excellent",
      metrics: {
        soilMoisture: 72,
        temperature: 26,
        humidity: 60,
        ph: 6.5,
      },
      location: { lat: 30.73, lng: 76.78 },
      image: null,
      lastWatered: "2024-01-19",
      fertilizer: "Urea",
      irrigation: "Flood irrigation",
      soilType: "Clay",
    },
    {
      id: 3,
      name: "East Field",
      crop: "Maize",
      area: "4.1 acres",
      plantedDate: "2024-01-20",
      expectedHarvest: "2024-05-20",
      overallHealth: 62,
      status: "fair",
      metrics: {
        soilMoisture: 55,
        temperature: 24,
        humidity: 42,
        ph: 7.2,
      },
      location: { lat: 30.735, lng: 76.785 },
      image: null,
      lastWatered: "2024-01-18",
      fertilizer: "DAP",
      irrigation: "Sprinkler",
      soilType: "Sandy loam",
    },
  ],

  diseaseDetectionResults: [
    {
      id: 1,
      fieldId: 1,
      fieldName: "North Field",
      disease: "Leaf Rust",
      confidence: 85,
      severity: "Medium",
      date: "2024-01-18",
      image: null,
      treatment: "Apply fungicide spray (Propiconazole)",
      description:
        "Fungal infection affecting wheat leaves. Early intervention recommended.",
      symptoms: [
        "Orange-red pustules on leaves",
        "Yellowing of affected areas",
      ],
      preventiveMeasures: [
        "Ensure proper air circulation",
        "Avoid overhead watering",
        "Remove infected plant debris",
      ],
    },
    {
      id: 2,
      fieldId: 2,
      fieldName: "South Field",
      disease: "Bacterial Blight",
      confidence: 92,
      severity: "Low",
      date: "2024-01-16",
      image: null,
      treatment: "Copper-based bactericide application",
      description: "Bacterial infection with minimal spread. Monitor closely.",
      symptoms: ["Water-soaked lesions", "Yellowing of leaf margins"],
      preventiveMeasures: [
        "Reduce humidity levels",
        "Improve drainage",
        "Use disease-free seeds",
      ],
    },
  ],

  // Empty chat history - starts fresh for each user
  chatHistory: [],

  quickActions: [
    {
      id: 1,
      title: "Water Fields",
      icon: "💧",
      action: "irrigation",
      urgent: false,
    },
    {
      id: 2,
      title: "Check Weather",
      icon: "🌤️",
      action: "weather",
      urgent: false,
    },
    {
      id: 3,
      title: "Disease Scan",
      icon: "🔍",
      action: "disease-scan",
      urgent: true,
    },
    {
      id: 4,
      title: "Market Prices",
      icon: "💰",
      action: "market",
      urgent: false,
    },
  ],

  connectedDevices: [
    {
      id: 1,
      name: "Soil Sensor 1",
      type: "sensor",
      location: "North Field",
      status: "active",
      batteryLevel: 85,
      lastReading: "2024-01-20T08:30:00Z",
      value: "65% moisture",
    },
    {
      id: 2,
      name: "Weather Station",
      type: "weather",
      location: "Central",
      status: "active",
      batteryLevel: 92,
      lastReading: "2024-01-20T08:45:00Z",
      value: "22°C, 45% humidity",
    },
    {
      id: 3,
      name: "Irrigation Pump 1",
      type: "irrigation",
      location: "South Field",
      status: "inactive",
      batteryLevel: 78,
      lastReading: "2024-01-20T06:15:00Z",
      value: "Last run: 2 hours",
    },
    {
      id: 4,
      name: "pH Sensor",
      type: "sensor",
      location: "East Field",
      status: "warning",
      batteryLevel: 45,
      lastReading: "2024-01-20T08:00:00Z",
      value: "pH 7.2",
    },
  ],

  settingsOptions: {
    notifications: {
      enabled: true,
      weatherAlerts: true,
      diseaseAlerts: true,
      irrigationReminders: true,
      marketUpdates: false,
    },
    units: {
      temperature: "celsius",
      area: "acres",
      volume: "liters",
    },
    language: "en",
    theme: "light",
    autoBackup: true,
    locationTracking: true,
    dataSharing: false,
  },

  weatherData: {
    current: {
      temperature: 22,
      humidity: 45,
      windSpeed: 12,
      condition: "Partly Cloudy",
      uvIndex: 6,
      visibility: 10,
      pressure: 1013,
    },
    forecast: [
      {
        date: "2024-01-21",
        high: 24,
        low: 18,
        condition: "Sunny",
        humidity: 40,
        windSpeed: 10,
        precipitation: 0,
      },
      {
        date: "2024-01-22",
        high: 26,
        low: 20,
        condition: "Partly Cloudy",
        humidity: 50,
        windSpeed: 15,
        precipitation: 10,
      },
      {
        date: "2024-01-23",
        high: 23,
        low: 17,
        condition: "Cloudy",
        humidity: 65,
        windSpeed: 18,
        precipitation: 30,
      },
      {
        date: "2024-01-24",
        high: 21,
        low: 15,
        condition: "Rainy",
        humidity: 80,
        windSpeed: 20,
        precipitation: 80,
      },
      {
        date: "2024-01-25",
        high: 25,
        low: 19,
        condition: "Sunny",
        humidity: 35,
        windSpeed: 8,
        precipitation: 0,
      },
    ],
  },

  cropDatabase: [
    {
      id: 1,
      name: "Wheat",
      season: "Rabi",
      duration: "120-150 days",
      soilType: ["Loamy", "Clay loam"],
      phRange: "6.0-7.5",
      temperature: "15-25°C",
      rainfall: "300-400mm",
      fertilizer: "NPK 120:60:40 kg/ha",
    },
    {
      id: 2,
      name: "Rice",
      season: "Kharif",
      duration: "90-120 days",
      soilType: ["Clay", "Clay loam"],
      phRange: "5.5-6.5",
      temperature: "22-32°C",
      rainfall: "1000-1500mm",
      fertilizer: "NPK 100:50:50 kg/ha",
    },
    {
      id: 3,
      name: "Maize",
      season: "Kharif/Rabi",
      duration: "90-120 days",
      soilType: ["Sandy loam", "Loamy"],
      phRange: "6.0-7.5",
      temperature: "20-30°C",
      rainfall: "500-750mm",
      fertilizer: "NPK 150:75:60 kg/ha",
    },
  ],

  marketPrices: [
    {
      crop: "Wheat",
      price: 2100,
      unit: "quintal",
      change: "+2.5%",
      date: "2024-01-20",
    },
    {
      crop: "Rice",
      price: 3200,
      unit: "quintal",
      change: "-1.2%",
      date: "2024-01-20",
    },
    {
      crop: "Maize",
      price: 1850,
      unit: "quintal",
      change: "+0.8%",
      date: "2024-01-20",
    },
  ],
};

export default mockData;
